import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { shimmer } from '../styles/animations';

export const SkeletonBodyBase = styled.div`
  display: flex;
  flex-direction: column;
`;

export const SkeletonBodyLine = styled.div`
  height: 0.75rem;
  animation: ${shimmer} 0.8s ease-in-out infinite alternate;
  background-color: rgba(0, 0, 0, 0.1);
  border-radius: 2px;

  & + & {
    margin-top: ${props => props.verticalGutter};
  }

  &:not(:first-child):last-child {
    width: 75%;
  }
`;

const SkeletonBody = ({ lines, style, verticalGutter, ...props }) => {
  const skeletonLines = Array.from(Array(lines).keys()).map(i => (
    <SkeletonBodyLine style={style} key={i} verticalGutter={verticalGutter} />
  ));
  return <SkeletonBodyBase {...props}>{skeletonLines}</SkeletonBodyBase>;
};

SkeletonBody.defaultProps = {
  lines: 2,
  style: undefined,
  verticalGutter: '0.75rem',
};

SkeletonBody.propTypes = {
  lines: PropTypes.number,
  style: PropTypes.object,
  verticalGutter: PropTypes.string,
};

export default SkeletonBody;
